import React from "react";
import { Truck } from "lucide-react";
import { StaticPage, Block } from "../components/StaticPage";

const ShippingPage = () => (
  <StaticPage icon={Truck} title="Livraison & retours" testid="shipping-page"
    intro="Tout savoir sur l'expédition de vos commandes et le retour de vos articles.">
    <Block title="Modes et délais de livraison">
      <p>Nous expédions vos commandes sous 24 à 48h ouvrées. Les délais indicatifs à réception :</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Livraison standard à domicile : 2 à 4 jours ouvrés — 5,90 €</li>
        <li>Livraison en point relais : 2 à 5 jours ouvrés — 3,90 €</li>
        <li>Livraison express : 24h ouvrées — 12,90 €</li>
      </ul>
      <p className="font-semibold text-slate-50">Livraison offerte dès 79 € d'achat.</p>
    </Block>
    <Block title="Suivi de commande">
      <p>Un email contenant votre numéro de suivi vous est envoyé dès l'expédition. Vous pouvez également suivre
      l'état de vos commandes depuis votre espace client, rubrique « Mes commandes ».</p>
    </Block>
    <Block title="Retours & remboursements">
      <p>Vous disposez de <strong>14 jours</strong> à compter de la réception pour retourner un article non utilisé,
      dans son emballage d'origine. La demande se fait depuis votre espace client (rubrique « Retours / SAV »).
      Le remboursement est effectué sous 14 jours après réception et vérification du colis retourné.</p>
      <p className="text-[13px] text-slate-400">Les pièces montées, électriques ou sur commande spéciale ne sont pas reprises.</p>
    </Block>
  </StaticPage>
);

export default ShippingPage;
